import React, { useContext, useEffect, useState } from "react";
import "./UserRoles.css";
import { NotificationManager } from 'react-notifications';
import PropTypes from 'prop-types';
import { Box
        ,Button
        ,Card
        ,Dialog ,DialogTitle ,DialogContent ,DialogActions
        ,Tab ,Tabs } from '@mui/material';

import { useParams } from "react-router-dom";
import { AuthContext } from '../../../contexts/authContext';
import AddIcon from '@mui/icons-material/Add';
import config from '../../../config';
import configMessage from '../../../utils/configMessage.json';
import CircleProgress  from "../../../components/CircleProgress/CircleProgress";
import PrivilegeList from './components/PrivilegeList';
import axios  from 'axios';

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      key   ={index}
      role  ="tabpanel"
      hidden={value !== index}
      id    ={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && children }
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index:    PropTypes.string.isRequired,
  value:    PropTypes.string.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}
  

export default function UserRoles() {
	const auth = useContext(AuthContext);

    const urlParams = useParams();

    const [loading, setLoading] = useState(true);
    const [oState, setoState] = useState({
       roles:              []
      ,activeTab:          ''
      ,roleDescriptions:   {}
      ,newRoleDescription: ''
      ,newRole:            {}
      ,modalDelRole:       false
    });

    const changeDesc = (index, event) => {
      let newRoleDescriptions    = oState.roleDescriptions;
      newRoleDescriptions[index] = event.target.value;
      setoState({ ...oState, roleDescriptions : newRoleDescriptions});
    }
    
    const changeNewDesc = (event) => {
      setoState({ ...oState, newRoleDescription : event.target.value});
    }

    const toggleDelRole = () => {
        //console.log('oState: ', oState);
        setoState({
            ...oState
            ,modalDelRole: !oState.modalDelRole
        });
    };

    const toggleTab = (event, tab) => {
        if (oState.activeTab !== tab) {
            let oTempState = { ...oState, activeTab: tab };
            if (tab === 'New') {
                oTempState = {
                    ...oTempState
                    ,roles:                 [ 'New', ...oState.roles ]
                    ,newRole:               oState.newRole
                    ,newRoleDescription:    ''
                };
            }
            setoState({ ...oTempState });
        }
    }

    const createTabsHeader = () => {
        let tabs = [];
        
        // New TabHeader
        const newIdTab = "New";
        tabs.push( <Tab {...a11yProps(newIdTab)} value={newIdTab} key={newIdTab} icon={<AddIcon className={oState.activeTab === newIdTab ? 'blu-font' : ''}/>} iconPosition="start" label="New Role"/>);
        
        const roles = oState.roles;
        for (let i = 0; i < roles.length; i++) { // ?<=
            if (roles[i]["ROLE_COD"]) {
                const idTab = (roles[i]["ROLE_COD"]).toString();
                const roleName = roles[i]["ROLE_DESC"];

                tabs.push( <Tab {...a11yProps(idTab)} value={idTab} key={idTab} label={roleName}/> );
            }
        }
        
        return tabs;
    }

    const createTabsBody = () => {
        let tabs = [];
        const roles = oState.roles;

        for (let i = 0; i < roles.length; i++) {
          if (roles[i]["ROLE_COD"]) {  
            const idTab = (roles[i]["ROLE_COD"]).toString();
            //   const roleName = roles[i]["ROLE_DESC"];
  
            tabs.push(
              <CustomTabPanel value={oState.activeTab}
                              index={idTab}
                              key  ={roles[i]["ROLE_DESC"]}>
                <Card className="tabPanelBody">
                  <div className="row" key="roleDescriptions">
                    <div className="col-lg-4 col-md-6 col-sm-12">
                      <div className="form-group">
                        <input name   = "roleDescriptions" type = "text" 
                          className   = "form-control"
                          placeholder = "Role description"
                          onChange    = {(event) => changeDesc(idTab,event)}
                          value       = {oState.roleDescriptions[idTab]}/>
                      </div>
                    </div>
                  </div>
  
                  <div className="row privileges-list-group" key="privileges">
                      <PrivilegeList kUser={urlParams.kUser} admin={false} save={true} forRoles={true} oPrivilegiRuolo={ oState.roles.find( o => ( o.ROLE_COD + '' ) === oState.activeTab ) } />
                  </div>
                </Card>
              </CustomTabPanel>
            );
          }
        }

        //tab new
        const newIdTab = "New";
        tabs.push(
          <CustomTabPanel value={oState.activeTab}
                          index={newIdTab}
                          key  ='new'>
            <Card className="tabPanelBody">
              <div className="row">
                <div className="col-lg-4 col-md-6 col-sm-12">
                  <div className="form-group">
                    <input name   = "newRoleDescription" type = "text" 
                      className   = "form-control"
                      placeholder = "Role description"
                      onChange    = {(event) => changeNewDesc(event)}
                      value       = {oState.newRoleDescription}/>
                  </div>
                </div>
              </div>
                
                <div className="row privileges-list-group" key="privileges">
                    <PrivilegeList kUser={urlParams.kUser} admin={false} save={true} forRoles={true} oPrivilegiRuolo={ oState.newRole } />
                </div>
            </Card>
          </CustomTabPanel>
        );

        return tabs;
    }

    const getRoles = async ( tab = "" ) => {
      setLoading(true);
      let activeTab = tab.toString();
      
      try {
        let response = await axios({
				method: 'get',
				url : "/users/role-list",
				params: {},
				baseURL: config.API_URL,
				headers: {Authorization: `Bearer ${await auth.getAccessTokenForBE()}`}		  
        })

        let data = response.data || [];

        if(data.length>0){
          activeTab = tab || ((data[0]["ROLE_COD"] || '').toString());
        }

        let roleDescriptions = {};
        for (let i = 0; i < data.length; i++) {
          roleDescriptions[data[i]["ROLE_COD"]] = data[i]["ROLE_DESC"];
        }
        
        const {
           PROG_RECORD
          ,ROLE_COD
          ,ROLE_DESC
          ,FLAG_GRANTED
          ,DATA_INSERIMENTO
          ,DATA_ULTIMA_MODIFICA
          ,NUM_TOT
          , ...oPrivilegeList
        } = data?.[0] || {}; // estraggo da data l'elenco dei privilegi in un unico oggetto escludendo le chiavi non necessarie (PROG_RECORD...).
        
        Object.keys(oPrivilegeList).forEach( sRoleName => {
          oPrivilegeList[ sRoleName ] = 'N'; // resetto a N tutti i privilegi per un nuovo ruolo.
        });
        
        setoState({
           ...oState
          ,newRole:          oPrivilegeList
          ,roles:            data
          ,loading:          false
          ,activeTab:        activeTab
          ,roleDescriptions: roleDescriptions
          ,modalDelRole: false
        });

      } catch (e) {
        NotificationManager.error(configMessage.UNEXPECTER_ERROR, "", config.TIMEOUT_MSG_ERROR_GEN);
      }

      setLoading(false);
    }

    const handleSubmitNew = async() => {
      setLoading(true);
      try {
        const pNewRole = oState.newRole;
        const params = {
           pRoleName: oState.newRoleDescription
          ,...pNewRole
        };

        let response = await axios({
           method: 'post'
          ,url : "/users/role-ins"
          ,params
          ,baseURL: config.API_URL
          ,headers: {Authorization: `Bearer ${await auth.getAccessTokenForBE()}`}  		  
          ,handleError: true
        })
        const nRetVal = response?.data || 0;
        
        if(nRetVal <= 0){
          let errorMessage = "";
          switch (nRetVal) {
            case -2:
              errorMessage = configMessage.NO_PRIVILEGES_ERROR;
              break;
            case -3:
              errorMessage = configMessage.ERROR_ROLE_INS_3;
              break;
            case -4:
              errorMessage = configMessage.ERROR_ROLE_INS_4;
              break;
            case -102:
              errorMessage = configMessage.NO_PRIVILEGES_ERROR;
              break;
            case -103:
              errorMessage = configMessage.ERROR_ROLE_INS_103;
              break;
            case -104:
              errorMessage = configMessage.ERROR_ROLE_INS_104;
              break;
            default:
              errorMessage = configMessage.UNEXPECTER_ERROR;
              break;
          }
          NotificationManager.error(errorMessage, "", config.TIMEOUT_MSG_ERROR_GEN);
          setLoading(false);
          return;
        }

        await getRoles();

        NotificationManager.success(configMessage.MSG_SUCCESS, "", config.TIMEOUT_MSG_SUCCESS);
      } catch (e) {
        NotificationManager.error(configMessage.UNEXPECTER_ERROR, "", config.TIMEOUT_MSG_ERROR_GEN);
      }
      setLoading(false);
    }

    const handleSubmitMod = async () => {
      // event.preventDefault();
      setLoading(true);
      try {
        const roles = oState.roles;
        const activeTab = oState.activeTab;

        let roleIndex = 0;
        for (let i = 0; i < roles.length; i++) {
          if((roles[i]["ROLE_COD"] + "") === activeTab){
            roleIndex = i;
            break;
          }
        }

        const params = {
           roleCod                  : activeTab
          ,roleName                 : oState.roleDescriptions[activeTab]
          ,...roles[roleIndex]
        };

        let response = await axios({
           method: 'post'
          ,url: "/users/role-mod"
          ,params
          ,baseURL: config.API_URL
          ,headers: {Authorization: `Bearer ${await auth.getAccessTokenForBE()}`} 		  
          ,handleError: true
        });
        const nRetVal = response?.data || 0;

        if(nRetVal <= 0){
          let errorMessage = "";
          switch (nRetVal) {
            case -1:
              errorMessage = configMessage.NO_PRIVILEGES_ERROR;
              break;
            case -2:
              errorMessage = configMessage.ERROR_ROLE_MOD_2;
              break;
            case -3:
              errorMessage = configMessage.ERROR_ROLE_INS_3;
              break;
            case -4:
              errorMessage = configMessage.ERROR_ROLE_INS_4;
              break;
            case -102:
              errorMessage = configMessage.NO_PRIVILEGES_ERROR;
              break;
            case -103:
              errorMessage = configMessage.ERROR_ROLE_INS_103;
              break;
            case -104:
              errorMessage = configMessage.ERROR_ROLE_INS_104;
              break;
            default:
              errorMessage = configMessage.UNEXPECTER_ERROR;
              break;
          }
          NotificationManager.error(errorMessage, "", config.TIMEOUT_MSG_ERROR_GEN);
          setLoading(false);
          return;
        }
        await getRoles(activeTab);
        NotificationManager.success(configMessage.MSG_SUCCESS, "", config.TIMEOUT_MSG_SUCCESS);
        
      } catch (e) {
        NotificationManager.error(configMessage.UNEXPECTER_ERROR, "", config.TIMEOUT_MSG_ERROR_GEN);
      }
      setLoading(false);
    }

    const handleSubmitDel = async () => {
      setLoading(true);
      try {
        const params = {
            roleCod: oState.activeTab
        };

        let response = await axios({
             method: 'post'
            ,url: "/users/role-del"
            ,params
			,baseURL: config.API_URL
			,headers: {Authorization: `Bearer ${await auth.getAccessTokenForBE()}`} 			
            ,handleError: true
        });
        const nRetVal = response?.data || 0;

        if(nRetVal <= 0){
          let errorMessage = "";
          switch (nRetVal) {
            case 0:
              errorMessage = configMessage.UNEXPECTER_ERROR;
              break;
            case -1:
              errorMessage = configMessage.UNEXPECTER_ERROR;
              break;
            case -2:
              errorMessage = configMessage.NO_PRIVILEGES_ERROR;
              break;
            case -3:
              errorMessage = configMessage.ERROR_ROLE_INS_3;
              break;
            case -4:
              errorMessage = configMessage.ERROR_ROLE_DEL_4;
              break;
            default:
              errorMessage = configMessage.UNEXPECTER_ERROR;
              break;
          }
          NotificationManager.error(errorMessage, "", config.TIMEOUT_MSG_ERROR_GEN);
          setLoading(false);
          return;
        }

        await getRoles();
        NotificationManager.success(configMessage.MSG_SUCCESS, "", config.TIMEOUT_MSG_SUCCESS);
        
      } catch (e) {
        NotificationManager.error(configMessage.UNEXPECTER_ERROR, "", config.TIMEOUT_MSG_ERROR_GEN);
      }
      setLoading(false);
    }

    useEffect(() => {
      getRoles();
    },[]);
    
    return (
        <div className='component-container home'>
			<div className='component-card'>
				<div id="role-list">
				{
					loading ? <CircleProgress /> : <>
					<div className="row-btn-submit">
						<div className="form-group mb-0">
						<Button variant="contained" color="primary" className={oState.activeTab === "New" ? "jr-btn" : "jr-btn hidden"} type="submit" onClick={handleSubmitNew}>Save New role</Button>
						<Button variant="contained" color="primary" className={oState.roles.length && oState.activeTab !== "New" ? "jr-btn" : "jr-btn hidden"} type="submit" onClick={handleSubmitMod}>Save</Button>
						<Button variant="contained" color="error"   className={oState.roles.length && oState.activeTab !== "New" ? "jr-btn" : "jr-btn hidden"} type="submit" onClick={toggleDelRole}  >Delete</Button>
						</div>
					</div>
				
					<Box sx={{ width: '100%' }}>
						<Box sx={{ width: '100%', borderBottom: 1, borderColor: 'divider' }}>
						<Tabs 
							value={ oState.activeTab }
							onChange={toggleTab}
							aria-label="wrapped label tabs example"
							className="tabs-header"
						>
							{ createTabsHeader() }
						</Tabs>
						</Box>
						{ createTabsBody() }
					
					</Box>  
					<Dialog open={oState.modalDelRole} toggle={toggleDelRole}>
						<DialogTitle>Delete Role: {oState.roleDescriptions[oState.activeTab]}</DialogTitle>
						<DialogContent>
							{configMessage.SETTINGS_ROLE_ACTION}<br/>
						</DialogContent>
						<DialogActions>
							<Button variant="contained" color="error" onClick={handleSubmitDel}>Delete</Button>
							<Button variant="outlined" onClick={toggleDelRole}>Cancel</Button>
						</DialogActions>
					</Dialog>
					</>
				} 
				</div>
			</div>
		</div>
    );
}